import { CreateRounded, DeleteRounded } from '@mui/icons-material'
import classNames from 'classnames'
import {
  getFieldNameByParamId,
  initProductImages,
} from 'feature/appeals/helpers'
import { TProductParams, TProduct } from 'feature/appeals/type'
import { orderFormSpace } from 'feature/productOrder/namespaces/orderFormSpace'
import { ScreenEnum, useScreen } from 'feature/screenMode'
import { useEffect, useState } from 'react'
import { Button, IconButton } from 'ui'
import { DragDropFileItem } from 'widget/DragDropFile/dragDropFileItem/DragDropFileItem'

import { TModalsType } from '../OrderInformationBlock'
import { ProductInformationParam } from '../ProductInformationParam/ProductInformationParam'

import style from './ProductInformation.module.scss'

type TProductInformation = {
  isEdit: boolean
  product: TProduct
  canDelete?: boolean
  openModal: (type: TModalsType, product?: TProduct) => void
}

// состав заявки - информация о параметрах
export function ProductInformation({
  product,
  isEdit,
  openModal,
  canDelete,
}: TProductInformation) {
  const screen = useScreen()
  const [productImages, setProductImages] = useState<
    orderFormSpace.Images[][] | []
  >([])

  const { id, parameters, files } = product

  useEffect(() => {
    if (parameters) {
      const imagesArray = initProductImages(id, parameters, files)
      setProductImages(imagesArray)
    }
  }, [product])

  const canEditParams =
    isEdit &&
    (!!product?.parameters?.length || !!product?.blankedParameters.length)

  const isParamsExist = !!product?.parameters?.length
  const isDesktopButtonVisible =
    (canEditParams || canDelete) && screen === ScreenEnum.desktop
  const isMobileButtonVisible =
    (canEditParams || canDelete) && screen !== ScreenEnum.desktop

  return (
    <div className={style.product}>
      <div className={style.cardHeader}>
        <span className='h2'>{product.name}</span>
        {isDesktopButtonVisible && (
          <div className={style.editButtons}>
            {canEditParams && (
              <IconButton
                className='buttonWithoutEffects'
                onClick={() => openModal('params', product)}
                data-testid={`product-edit-icon-${id}`}
              >
                <CreateRounded />
              </IconButton>
            )}

            {canDelete && (
              <IconButton
                className='buttonWithoutEffects'
                onClick={() => openModal('delete', product)}
                data-testid={`product-delete-icon-${id}`}
              >
                <DeleteRounded />
              </IconButton>
            )}
          </div>
        )}
      </div>
      {isParamsExist && (
        <>
          <span className={classNames('h4', style.paramsTitle)}>Параметры</span>
          <div className={style.paramsList}>
            {product?.parameters?.map((parameter: TProductParams) => {
              if (parameter.typeCode === 'IMAGES') return <></>
              return (
                <ProductInformationParam
                  key={parameter.name}
                  settings={parameter}
                />
              )
            })}

            <div className={style.filesParameter}>
              {!!productImages?.length &&
                productImages?.map((images, index) => (
                  <div className={style.images} key={index}>
                    {images[0].paramId && parameters && (
                      <span className={style.imagesListTitle}>
                        {getFieldNameByParamId(images[0].id, parameters) + ':'}
                      </span>
                    )}
                    <div className={style.imagesList}>
                      {images.map((image, imageIndex) => (
                        <DragDropFileItem
                          key={image.id}
                          item={image}
                          index={imageIndex}
                        />
                      ))}
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </>
      )}
      {isMobileButtonVisible && (
        <div className={style.buttonsWrapper}>
          {canEditParams && (
            <Button
              variant='contained'
              color='secondary'
              onClick={() => openModal('params', product)}
              data-testid={`product-edit-btn-${id}`}
            >
              <CreateRounded color='primary' />
            </Button>
          )}

          {canDelete && (
            <Button
              variant='contained'
              color='secondary'
              onClick={() => openModal('delete', product)}
              data-testid={`product-delete-btn-${id}`}
            >
              <DeleteRounded color='primary' />
            </Button>
          )}
        </div>
      )}
    </div>
  )
}
